// 商品列表页
import * as React from 'react';
import * as ReactDOM from 'react-dom';

import Header from '../../../components/Header/index';
import TopNav from '../../../components/TopNav/index';
import '../../../components/common';
import '../../../components/shop/common';
import config from '../../../utils/config';
import request from '../../../utils/request';
import { GetQueryString, pushPath, getShopInfo } from '../../../utils/utils';

let loadBtn = true;
let isLast = false;

export default class Offerlist extends React.Component < {}, any > {
    constructor(props: any) {
        super(props);
        const level = GetQueryString('level');
        this.state = {
            cateLevel: level ? parseInt(level, 10) : '',
            goodList: [],
            page: 1,
            pageSize: 10,
            shopInfo: {},
            leftGoodsList: [],
            rightGoodsList: []
        };
    }

    public componentDidMount() {
        getShopInfo().then((r: any) => {
            this.setState({
                shopInfo: r
            });
            document.title = r.shop_name;
        });
        this._getData();

        window.addEventListener('scroll', this.scrollAction.bind(this));
    }

    public componentWillUnmount() {
        window.removeEventListener('scroll', this.scrollAction.bind(this));
    }

    public render() {
        const state = this.state;
        const imgHeight = window.innerWidth * 0.91 / 2;
        return (
            <div>
                <Header />
                <div className="gysplist">
                    <div className="gysplistleft">
                        {
                            state.leftGoodsList.map(v => {
                                return this.renderGoodsItem(v)
                            })
                        }
                    </div>
                    <div className="gysplistright">
                        {
                            state.rightGoodsList.map(v => {
                                return this.renderGoodsItem(v)
                            })
                        }
                    </div>
                  </div>
                  {
                        (isLast && this.state.leftGoodsList.length > 0) ? <p className="prompt">已显示全部商品</p> : null
                    }
                    { this.state.leftGoodsList.length === 0 && this.state.rightGoodsList.length === 0 &&
                    <div className="nothings"><img src={require('../../../assets/images/tz_15.png')} />
                            <p>暂无内容</p>
                          </div>
        }
        <TopNav />
        </div>
        )
    }

    private async _getData() {

        const path: any = GetQueryString('keyword');
        const cateSecs: any = GetQueryString('cid');
        const id: number = (window as any).shopId;

        if (loadBtn) {
            loadBtn = false;

            const r = await request({
                data: {
                    cateFir: this.state.cateLevel === 1 ? cateSecs : '',
                    cateSec: this.state.cateLevel !== 1 ? cateSecs : '',
                    goodsName: decodeURI(path),
                    page: this.state.page,
                    pageSize: this.state.pageSize,
                    shopDomain: id,
                },
                method: 'post',
                url: `${config.PHPAPI}api/wshop/goods/goods-list`,

            })

            if (r.error_code === 0) {
                if (r.data.pages >= r.data.page_count) {
                    loadBtn = false;
                    isLast = true;
                } else {
                    loadBtn = true;
                }

                const leftGoodsList: any = [];
                const rightGoodsList: any = [];

                r.data.model.forEach((v, k) => {
                    if (k % 2 === 0) {
                        leftGoodsList.push(v);
                    } else {
                        rightGoodsList.push(v);
                    }
                });

                this.setState({
                    goodList: this.state.goodList.concat(r.data.model),
                    leftGoodsList: this.state.leftGoodsList.concat(leftGoodsList),
                    rightGoodsList: this.state.rightGoodsList.concat(rightGoodsList)
                })

            }
        }

    }

    // 滚动加载
    private scrollAction() {
        const _THIS = this;
        if (document.body.scrollHeight - document.body.scrollTop - window.innerHeight < 50 || document.body.scrollHeight - document.documentElement.scrollTop - window.innerHeight < 50) {
            if (!loadBtn) {
                return;
            }

            _THIS.setState({
                page: _THIS.state.page + 1,
            }, () => {
                if (loadBtn) {
                    _THIS._getData()
                }
            });
        }
    }

    /**
     * [renderGoodsItem 渲染商品]
     * @param  {[any]} v [商品数据]
     * @return {[type]}    [description]
     */
    private renderGoodsItem(v: any) {
        return (
            <div className="card"><a href="javascript: void(0);" onClick={() => pushPath('/offer', `?id=${v.goods_id}`) }><img src={v.img_url} alt="" />
                          <p className="text1">{ v.goods_name }</p>
                          {
                              v.apply_demo === '1' && <span className="xiaoyang">有免费小样</span>
                          }
                          {
                            v.price_type === '3' ?
                            <p className="text2">面议</p> :
                            <p className="text2">{v.symbol}{v.price}</p>
                        }
                        </a></div>
        )
    }
}

ReactDOM.render(
    <Offerlist />,
    document.getElementById('root') as HTMLElement
);


// WEBPACK FOOTER //
// ./src/containers/shop/offerlist/index.tsx